import React, { useContext } from 'react'
import { LogoContext } from '../../contexts/LogoContext'
import LogoSizeSlider from './LogoSizeSlider'

const UploadLogo = () => {
  const { logos, dispatch } = useContext(LogoContext)

  const fileSelectedHandler = event => {
    event.preventDefault()

    let reader = new FileReader()
    let file = event.target.files[0]
    if (file === undefined) return

    var fileInfo = document.getElementById('choose-file')
    var fileLabel = document.getElementById('file-label')
    if (fileInfo.value === '') {
      fileLabel.innerHTML = 'Choose file'
    } else {
      var theSplit = fileInfo.value.split('\\')
      fileLabel.innerHTML = theSplit[theSplit.length - 1]
      dispatch({ type: 'UPDATE_LOCAL_LABEL', localLabel: fileLabel.innerHTML })
    }

    reader.readAsDataURL(file)
    reader.onloadend = () => {
      dispatch({ type: 'UPDATE_LOCAL_URL', url: reader.result })
      dispatch({ type: 'UPDATE_LOCAL_FILE', localFile: file })
    }
  }

  const logoSizeHandler = value => {
    dispatch({ type: 'UPDATE_LOCAL_WIDTH', width: value })
  }

  return (
    <div className="upload-logo">
      <input
        id="choose-file"
        type="file"
        onChange={fileSelectedHandler}
        accept="image/*,.pdf"
      />
      <small>
        <label id="file-label">{logos.localLabel}</label>
      </small>
      <LogoSizeSlider
        id="local-logo-size"
        imageSrc={logos.localUrl}
        value={logos.localWidth}
        onChange={logoSizeHandler}
      />
    </div>
  )
}

export default UploadLogo
